import { SET_NOTIFICATION, HIDE_NOTIFICATION } from "./constants";

export const setNotification = payload => dispatch => {
  dispatch({ payload, type: SET_NOTIFICATION });
};

export const hideNotification = payload => dispatch => {
  dispatch({ type: HIDE_NOTIFICATION, payload });
};
